import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import Socials from "../components/Socials";
import FormikInput from "../../../components/formik/Input";
import FormikSelect from "../../../components/formik/Select";
import signupHandler from "./handler";
import loginHandler, { routeAfterLoginOrSignup } from "../login/handler";
import withMiddleware from "../../../middleware";
import { signupUserEmailPass, loginUserGoogle, loginUserApple } from "../../../actions";
import { useUtils } from "../../../utils";
import { updateUser } from "../../../actions/app";

const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  gender: Yup.string().required("Gender is required"),
  birthDate: Yup.date().required("Date of Birth is required"),
  email: Yup.string().email("Invalid email address").required("Email is required"),
  password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
});

function Signup(props) {
  const { userDetails, handleLogging, loading, setLoading } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const { showToast } = useUtils();
  const [initialValues, setInitialValues] = useState({
    ...userDetails,
    firstName: "",
    lastName: "",
    gender: "",
    birthDate: "",
    email: "",
    password: "",
    isSocialSignupFlow: false,
  });
  const isSignUpFlow = initialValues?.isSocialSignupFlow;

  useEffect(() => {
    setInitialValues((old) => ({
      ...old,
      ...userDetails,
    }));
  }, [userDetails]);

  async function handleSignupEmailPass(firebaseUser, userDetails) {
    try {
      setLoading(true);
      if (firebaseUser?.additionalUserInfo?.isNewUser) {
        props.service.updateUser(firebaseUser.user);
        await handleSignup(userDetails);
      } else {
        handleLogging(firebaseUser?.user, firebaseUser);
      }
    } catch (err) {
      handleError(err);
    } finally {
      // setLoading(false);
    }
  }

  async function handleSignup(userDetails) {
    // Getting query string before signing up user to fix the un-expected routing on the main app listener.
    const queryStr = window.location.search;
    return signupHandler(props.service, userDetails)
      .catch(handleError)
      .then(async () => {
        setLoading(true);
        showToast("success", "You are signed up successfully, logging you in now!");
        const { user, route } = await loginHandler(props.service).catch(handleError);
        dispatch(updateUser(user));
        routeAfterLoginOrSignup(history, route, user, true, queryStr);
      });
  }

  function handleError(error) {
    showToast("error", error?.message);
    setLoading(false);
  }

  function handleSocialSignup() {
    // setLoading(false);
  }

  return (
    <>
      <div
        className="form-container sign-up-container"
        style={{
          pointerEvents: loading ? "none" : "auto",
        }}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={(values) => {
            setLoading(true);
            const newValues = { ...values };
            delete newValues.email;
            delete newValues.password;
            delete newValues.isSocialSignupFlow;
            // console.log(newValues, "newValues");
            if (initialValues?.isSocialSignupFlow) {
              handleSignup(newValues);
            } else {
              dispatch(
                signupUserEmailPass(
                  (user) => {
                    handleSignupEmailPass(user, newValues);
                  },
                  values.email,
                  values.password,
                  handleError
                )
              );
            }
            // Map body = {
            //   "firstName": firstName,
            //   "lastName": lastName,
            //   "gender": gender,
            //   "birthDate": birthDate,
            //   "isSolo": "true"
            // };
            // return await ServiceUtils().post("/user/profile", body);
            /**
            TODO: Account sign up.
            1. First we will have to create an account at firebase and then use that
            user information to login and after that we need to call the above API.
            2. The above code is used to send data to the backend to signup a user.
            2. The above API will use firebase token to create new user account.
            3. Once the account is created we should display some sort of a message that says
            user that you can open app to continue further.
           */
            // handle form submission here
          }}
        >
          {({ handleSubmit, errors }) => (
            <form onSubmit={handleSubmit}>
              <h1>{isSignUpFlow ? "Almost there!" : "Create Account"}</h1>
              {!isSignUpFlow ? (
                <Socials
                  handleGoogleSignIn={() => {
                    setLoading(true);
                    dispatch(loginUserGoogle(handleSocialSignup, handleError));
                  }}
                  handleAppleSignIn={() => {
                    setLoading(true);
                    dispatch(loginUserApple(handleSocialSignup, handleError));
                  }}
                />
              ) : null}
              <span className={isSignUpFlow ? "mb-2" : ""}>
                {isSignUpFlow
                  ? "Looks like you are new here please provide these details to create an account"
                  : "or use your email for registration"}
              </span>
              {!initialValues?.firstName ? <FormikInput name="firstName" type="text" placeholder="First Name" /> : null}
              {!initialValues?.firstName ? <FormikInput name="lastName" type="text" placeholder="Last Name" /> : null}
              <div className="gender-and-dob">
                <FormikSelect name="gender">
                  <option value="" disabled>
                    Select Gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Prefer not to disclose">Prefer not to disclose</option>
                  <option value="Others">Others</option>
                </FormikSelect>
                <FormikInput name="birthDate" type="date" placeholder="Date Of Birth" />
              </div>
              {!isSignUpFlow ? <FormikInput name="email" type="email" placeholder="Email" /> : null}
              {!isSignUpFlow ? <FormikInput name="password" type="password" placeholder="Password" /> : null}
              <button className="mb-1" type="submit">
                Continue
              </button>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
}

export default withMiddleware(Signup);
